import DesktopNewTabAnchor from './DesktopNewTabAnchor';

export * from './DesktopNewTabAnchor';
export default DesktopNewTabAnchor;
